import {
  AfterViewInit,
  Component,
  ContentChildren,
  Input,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { AccordionMode } from '@boels/models';
import { Subscription } from 'rxjs';
import { AccordionItemComponent } from './accordion-item.component';

@Component({
  selector: 'boels-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements AfterViewInit, OnDestroy {
  @ContentChildren(AccordionItemComponent)
  items: QueryList<AccordionItemComponent>;
  @Input() mode: AccordionMode = AccordionMode.MULTIPLE;

  openChild: AccordionItemComponent;
  subs$ = new Subscription();

  ngAfterViewInit(): void {
    this.items.forEach((accordionItem: AccordionItemComponent) => {
      this.subs$.add(
        accordionItem.toggleEmitter.subscribe(
          (item: AccordionItemComponent) => {
            this.expand(item);
          },
        ),
      );
    });
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }

  expand(item: AccordionItemComponent): void {
    if (item === this.openChild && item.expanded) {
      return item.close();
    }
    item.toggle();
    this.openChild = item;

    // Multiple mode, don't close others.
    if (this.mode === AccordionMode.MULTIPLE) {
      return;
    }

    // Single mode, close others.
    this.items
      .filter((accordionItem) => accordionItem !== this.openChild)
      .map((accordionItem) => accordionItem.close());
  }
}
